import Reactotron from 'reactotron-react-js'
import { reactotronRedux } from 'reactotron-redux'
import sagaPlugin from 'reactotron-redux-saga'

const configureOptions = { name: 'Oikos Web' }
if (process.env.REACT_APP_REACTOTRON_HOST) {
  configureOptions.host = process.env.REACT_APP_REACTOTRON_HOST
} else {
  configureOptions.host = 'localhost'
}

const tron = Reactotron
  .configure(configureOptions)
  .use(reactotronRedux())
  .use(sagaPlugin())
  .connect()

tron.clear()

console.tron = tron

export default tron
